'use client';

import React, { useState } from 'react';
import SkillPill from '../individual-components/skill-pill';

const TechnicalSkills = ({ list }) => {
    const [showAll, setShowAll] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const detailedSkills = (list || [])?.filter(skill => skill.expertiseLevel);
    const detailedSkillsLength = (detailedSkills || [])?.length;
    const maxVisible = detailedSkillsLength > 10 ? 15 : detailedSkillsLength + 10;
    const skillsToShow = showAll ? list : (list || [])?.slice(0, maxVisible);

    const toggleShowAll = () => setShowAll(!showAll);
    const toggleShowDetails = () => setShowDetails(!showDetails);

    return (
        <div
            id="technicalSkills"
            className="flex flex-col border-t border-[#6670854D] py-10 xs:py-5"
        >
            <div className="flex justify-between items-center gap-3 xs:gap-1 pr-1">
                <h2 className="text-header text-[20px] xs:text-[16px] leading-[22px] font-bold">
                    Technical Skills
                </h2>
                <div className="flex items-center gap-4 xs:gap-2">
                    <p className="text-[16px] xs:text-[12px] font-bold leading-[22px] font-liberation">
                        Detailed View
                    </p>
                    <label
                        htmlFor="detailed-skills-toggle"
                        className="inline-flex items-center cursor-pointer"
                        aria-label='toggle'
                    >
                        <input
                            type="checkbox"
                            className="sr-only peer"
                            id="detailed-skills-toggle"
                            checked={showDetails}
                            onChange={toggleShowDetails}
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#eb532e]" />
                    </label>
                </div>
            </div>
            <div className="flex flex-wrap items-center gap-[12px] mt-5 transition-[height] duration-500">
                {skillsToShow.map((skill, i) =>
                    showDetails && skill?.expertiseLevel ? (
                        <div key={i} className="w-full flex sm:flex-col sm:items-start items-center justify-between">
                            <div className="flex w-full justify-between mb-2">
                                <span className="text-primary font-liberation min-w-[200px] text-[16px] sm:text-[14px] leading-7">
                                    {skill.skillName}
                                </span>
                                <span className="hidden sm:block text-left text-primary font-liberation text-[14px] leading-7">
                                    {skill.experience} Years
                                </span>
                            </div>
                            <div className="w-full">
                                <div className="h-2 rounded-full bg-[#E8F2F6]">
                                    <div
                                        className="h-2 rounded-full bg-[#eb532e]"
                                        style={{ width: parseInt(skill.expertiseLevel, 10) * 33.33 + '%' }}
                                    />
                                </div>
                            </div>
                            <span className="min-w-[100px] sm:hidden text-right sm:text-left text-primary font-liberation text-[16px] leading-7">
                                {skill.experience} Years
                            </span>
                        </div>
                    ) : (
                        <SkillPill key={i} label={skill.skillName} />
                    )
                )}
                {list.length > maxVisible && (
                    <button
                        onClick={toggleShowAll}
                        className="rounded-[29px] font-liberation transition-all duration-500 cursor-pointer text-[16px] xs:text-[12px] leading-[18px] text-center px-[32px] py-[14px] bg-[#FFF3F0] hover:bg-[#EB532E] text-header hover:text-[#fff]"
                    >
                        {showAll ? 'View Less' : `${list.length - maxVisible}+ More`}
                    </button>
                )}
            </div>
        </div>
    );
};

export default TechnicalSkills;
